export default __webpack_public_path__ + "static/media/sponsor-icon-bottom-nav-mobile-active.3008ce71.webp";